import { render, staticRenderFns } from "./soursedet.vue?vue&type=template&id=56179159&scoped=true&"
import script from "./soursedet.vue?vue&type=script&lang=js&"
export * from "./soursedet.vue?vue&type=script&lang=js&"
import style0 from "./soursedet.vue?vue&type=style&index=0&id=56179159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56179159",
  null
  
)

export default component.exports